import React from 'react';
import styled, { keyframes } from 'styled-components';

const LoadingDotsComponent:React.FC = () => {
  return (
    <LoadingDots>
      <Dot />
    </LoadingDots>
  )
};

const spin = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}`;


const dotAnimation = keyframes`
  0% {
    content: "";
  }
  20% {
    content: ".";
  }
  40% {
    content: "..";
  }
  60% {
    content: "...";
  }
  80% {
    content: "";
  }
`;

const LoadingDots = styled.div`
  margin: 0 7px;
  display: flex;
  flex-direction: column;
  font-size: 35px;
  color: gray;
`;

const Dot = styled.div`
  &:after {
    content: "";
    display: inline-block;
    animation: ${dotAnimation} 1s linear infinite;
  }
`;

export default LoadingDotsComponent;
